import { useQuery } from '@tanstack/react-query';
import { getTasks } from 'api/tasks';
import { tasksKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';
import { ITasksRequest } from 'types/task';

export const useTasksQuery = (filters: ITasksRequest['filters']) => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: tasksKeys.list(companyId, filters ?? {}),
    queryFn: () => getTasks({ filters: filters ?? {} }).then((res) => res),
    enabled: !!companyId
  });
};
